import axios from 'axios'

// http://localhost:5001/api
// https://ifeltbackend-9dbae009ec52.herokuapp.com/api


const API_BASE_URL = 'https://ifeltbackend-9dbae009ec52.herokuapp.com/api'; // Replace with your actual API URL
 // const API_BASE_URL = "http://localhost:5001/api" // Replace with your actual API URL
 const MOVIES_API_KEY = "9238b7b16af88f2b4461d6e70ce285f6"

 const API = axios.create({
   baseURL: API_BASE_URL, // Replace with your API base URL
   headers: {
     "Content-Type": "application/json",
   },
   // any other headers can go here
 })

 // Attach the JWT (if the user is logged in) to every request.
 API.interceptors.request.use((config) => {
   const token = localStorage.getItem("ifelt_token")
   if (token) config.headers.Authorization = `Bearer ${token}`
   return config
 })

 export { API, API_BASE_URL, MOVIES_API_KEY }
